import { Directive } from '@angular/core';

@Directive()
export class TileClusterBaseComponent {}
